import { MuteMotionSource } from 'motion/MuteMotionSource';
import { SAVE_EDIT_MOTION_SOURCE } from 'state/actions';
import RootState from 'state/RootState';
import { Command, CommandFunction } from './Command';

export class EditMutedMotionCommand extends Command {
  newValue: string;
  previousValue: string;
  execute(firstTime?: boolean | undefined): CommandFunction {
    return (dispatch: Function, getState: () => RootState) => {
      if (firstTime) {
        const { flyer } = getState();
        const mutedMotionSource = flyer.motionSource as MuteMotionSource;
        this.newValue = JSON.stringify(mutedMotionSource.asData());
        this.previousValue = flyer.lastTimeMotionSourceValues!;
      }
      dispatch({
        type: SAVE_EDIT_MOTION_SOURCE,
        data: this.newValue
      });
    };
  }
  undo(): CommandFunction {
    return (dispatch: Function, getState: () => RootState) => {
      dispatch({
        type: SAVE_EDIT_MOTION_SOURCE,
        data: this.previousValue
      });
    };
  }
}



// WEBPACK FOOTER //
// ./src/state/commands/EditMutedMotionCommand.ts